// CSS Modules - component class name prefix: WishList__

<template>
  <div :class="[$style.container, { WishList__open: wishListOpen }]">
    <div :class="$style.wishList">
      <div @click="handleTabClick" :class="$style.tab">
        <div :class="$style.text">{{ config.buttonText }}</div>
        <i class="fas fa-list"></i>
      </div>
      <div id="wishListBadge" :class="$style.badge">
        {{ counter }}
      </div>
      <div :class="$style.title">
        {{ config.title }} - {{ config.counterText }} ({{ counter }})
      </div>
      <div :class="$style.list">
        <p v-if="counter === 0" :class="$style.emptyText">
          {{ config.emptyText }}
        </p>
        <template v-if="wishList">
          <template v-for="(item, index) in wishList">
            <WishListItem
              v-if="checkHasLangAndFlag(getCountries(item))"
              :item="item"
              :index="index"
              :countries="getCountries(item)"
              :productTypeLabel="
                item.types.length > 1 ? config.types : config.type
              "
              :key="`key_${index}_${JSON.stringify(item)}`"
              @removeItem="removeItem"
            />
            <a
              :class="$style.downLoadWrapper"
              :href="item.downloads[0].url"
              :key="`key_${index}_${JSON.stringify(item)}`"
              v-if="!checkHasLangAndFlag(getCountries(item))"
              target="_blank"
              download="download"
            >
              <WishListItem
                :item="item"
                :index="index"
                :countries="getCountries(item)"
                :productTypeLabel="
                  item.types.length > 1 ? config.types : config.type
                "
                @removeItem="removeItem"
              />
            </a>
          </template>
        </template>
      </div>
      <form :class="$style.form">
        <template v-if="!formSubmitted">
          <FormInput
            v-model="email"
            :label="config.formText"
            :errorMessage="errorMessage"
            :error="formError"
            :placeholder="config.emailPlaceholder"
            @input="formError = false"
          />
          <div :class="$style.label">
            <Button
              colour="blue"
              type="submit"
              :isForm="true"
              @close="handleSubmit"
              ariaLabel="submit e-mail"
            />
            <i class="fas fa-caret-right"></i>
          </div>
        </template>
        <template v-else>
          <div>{{ config.successMessage }}</div>
        </template>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import * as Storage from "../../shared/Storage";
import FormInput from "../FormInput/FormInput";
import Button from "../Button/Button";
import WishListItem from "./WishListItem";

export default {
  name: "WishList",
  components: {
    FormInput,
    Button,
    WishListItem
  },
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      wishList: null,
      counter: 0,
      wishListOpen: false,
      badge: null,
      email: null,
      formError: false,
      formSubmitted: false,
      errorMessage: "",
      formData: {
        ftlUrl: "",
        email: "",
        userLang: ""
      },
      wtTrack: window.wtTrack
    };
  },
  computed: {
    isEmail: function() {
      return new RegExp(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/).test(
        this.email
      );
    }
  },
  methods: {
    checkLocalStorage() {
      this.wishList = Storage.getLocalStorage("wishList", true);
      if (this.wishList) {
        this.counter = this.wishList.length;
      } else {
        this.counter = 0;
      }
    },
    checkHasLangAndFlag(countries) {
      const urlsWithLanguage =
        countries.filter(country => !!country.language && !!country.flag) || [];
      return urlsWithLanguage.length;
    },
    handleTabClick() {
      if (this.wishListOpen) {
        this.wishListOpen = false;
        this.checkLocalStorage();
        this.showBadge();
      } else {
        this.formSubmitted = false;
        this.checkLocalStorage();
        this.wishListOpen = true;
        this.hideBadge();
      }
    },
    showBadge() {
      if (this.counter !== 0) {
        this.badge.style.transition = "opacity 200ms ease 300ms";
        this.badge.style.opacity = 1;
      }
    },
    getCountries(docItem) {
      const countries = [];

      for (let i = 0; i < docItem.downloads.length; i++) {
        if (
          docItem.downloads[i].languageCodes[0] ||
          docItem.downloads[i].flag
        ) {
          countries.push({
            flag: docItem.downloads[i].flag,
            language: docItem.downloads[i].languageCodes[0] || null,
            url: docItem.downloads[i].url
          });
        }
      }

      return countries;
    },
    hideBadge() {
      this.badge.style.transition = "none";
      this.badge.style.opacity = 0;
    },
    updateAllBrowserTabs() {
      this.checkLocalStorage();
    },
    removeItem(index) {
      this.checkLocalStorage();
      this.wishList.splice(index, 1);
      this.counter = this.wishList.length;
      Storage.setLocalStorage("wishList", this.wishList, true);
    },
    removeAllItems() {
      this.checkLocalStorage();
      this.wishList = [];
      this.counter = 0;
      Storage.setLocalStorage("wishList", this.wishList, true);
    },
    handleSubmit() {
      if (this.isEmail && this.counter !== 0) {
        this.wtTrack({ cat: "WISHLIST" });
        this.formError = false;
        this.formData.ftlUrl = this.config.ftlUrl;
        this.formData.email = this.email;
        this.formData.wishListItems = this.wishList.map(listItem => {
          const allTypes =
            listItem.types && !!listItem.types.length
              ? listItem.types.join(", ")
              : "";
          let allTypesWithLabel = allTypes
            ? `${
                listItem.types.length > 1 ? this.config.types : this.config.type
              } ${allTypes}`
            : "";
          return {
            section: listItem.section,
            types: allTypesWithLabel,
            title: listItem.title,
            downloads: listItem.downloads.map(downloadItem => {
              if (downloadItem.url.indexOf('://') === -1)
              {
                downloadItem.url =  window.top.location.protocol + '://' + window.top.location.hostname + downloadItem.url;
              }
              return {
                url: downloadItem.url,
                languageCodes: downloadItem.languageCodes
              };
            })
          };
        });
        this.formData.userLang = window.currentLanguage || "en";
        axios({
          url: this.config.serviceUrl,
          method: "post",
          data: this.formData,
          responseType: "json"
        })
          .then(response => {
            if (!response.data.success) {
              console.error(
                `Response after submit (${this.config.serviceUrl}): ${
                  response.data.message
                } - ${response.data.errormessage}`
              );
              this.errorMessage = this.config.technicalErrorMessage;
              this.formError = true;
            } else {
              this.removeAllItems();
              this.formSubmitted = true;
              this.email = null;
            }
          })
          .catch(error => {
            this.errorMessage = this.config.technicalErrorMessage;
            this.formError = true;
            console.error(
              `Response after submit (${this.config.serviceUrl}): ${error}`
            );
          });
      } else if (this.isEmail && this.counter === 0) {
        this.errorMessage = this.config.formErrorMessage;
        this.formError = true;
      } else if (!this.isEmail) {
        this.errorMessage = this.config.emailErrorMessage;
        this.formError = true;
      }
    }
  },
  mounted() {
    window.addEventListener("storage", this.updateAllBrowserTabs);
    window.addEventListener("addToWishList", this.checkLocalStorage);
    this.badge = document.getElementById("wishListBadge");
    this.checkLocalStorage();
    this.showBadge();
  },
  destroyed() {
    window.removeEventListener("storage", this.updateAllBrowserTabs);
    window.removeEventListener("addToWishList", this.checkLocalStorage);
  }
};
</script>

<style module lang="scss">
@import "./WishList.scss";
</style>
